import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import attendeeCameraStatus from '@shoflo/studio-redux/reducers/attendee/attendeeCameraStatus';
import attendeeNetworkHealth from '@shoflo/studio-redux/reducers/attendee/attendeeNetworkHealth';
import attendeeReceivedFrame from '@shoflo/studio-redux/reducers/attendee/attendeeReceivedFrame';
import attendeeMuteStatus from '@shoflo/studio-redux/reducers/attendee/attendeeMuteStatus';
import attendeeRoster from '@shoflo/studio-redux/reducers/attendee/attendeeRoster';
import attendeeDetails from '@shoflo/studio-redux/reducers/attendee/attendeeDetails';
import attendeePresence from '@shoflo/studio-redux/reducers/attendee/attendeePresence';
import attendeeVoiceIntensity from '@shoflo/studio-redux/reducers/attendee/attendeeVoiceIntensity';
import userBackground from '@shoflo/studio-redux/reducers/backgroundFilters/userBackground';
import backgrounds from '@shoflo/studio-redux/reducers/backgrounds/backgrounds';
import banners from '@shoflo/studio-redux/reducers/banners/banners';
import brandingSettings from '@shoflo/studio-redux/reducers/branding/brandingSettings';
import { broadcast } from '@shoflo/studio-redux/reducers/broadcast/broadcast';
import { broadcastRoles } from '@shoflo/studio-redux/reducers/broadcastRoles/broadcastRoles';
import broadcastEventMedia from '@shoflo/studio-redux/reducers/event/eventMedia';
import directorRequests from '@shoflo/studio-redux/reducers/knocks/directorRequests';
import knocks from '@shoflo/studio-redux/reducers/knocks/knocks';
import mediaPlayerSettings from '@shoflo/studio-redux/reducers/mediaPlayerSettings/mediaPlayerSettings';
import meeting from '@shoflo/studio-redux/reducers/meeting/meeting';
import videoInputDevice from '@shoflo/studio-redux/reducers/meeting/videoInputDevice';
import audioInputDevice from '@shoflo/studio-redux/reducers/meeting/audioInputDevice';
import audioOutputDevice from '@shoflo/studio-redux/reducers/meeting/audioOutputDevice';
import videoDeviceLost from '@shoflo/studio-redux/reducers/meeting/videoDeviceLost';
import transformedVideoInputs from '@shoflo/studio-redux/reducers/meeting/transformedVideoInputs';
import modal from '@shoflo/studio-redux/reducers/modal/modal';
import notification from '@shoflo/studio-redux/reducers/notification/notification';
import overlays from '@shoflo/studio-redux/reducers/overlay/overlays';
import permissions from '@shoflo/studio-redux/reducers/permissions/permissions';
import startProgram from '@shoflo/studio-redux/reducers/program/startProgram';
import featuredPresenter from '@shoflo/studio-redux/reducers/program/featuredPresenter';
import program from '@shoflo/studio-redux/reducers/program/program';
import sceneLayers from '@shoflo/studio-redux/reducers/program/sceneLayers';
import readinessCheck from '@shoflo/studio-redux/reducers/readinessCheck/readinessCheck';
import showReadinessCheck from '@shoflo/studio-redux/reducers/readinessCheck/showReadinessCheck';
import sandboxMeetingStatus from '@shoflo/studio-redux/reducers/readinessCheck/sandboxMeetingStatus';
import sandboxMeetingSession from '@shoflo/studio-redux/reducers/readinessCheck/sandboxMeetingSession';
import attendeeReadinessCheck from '@shoflo/studio-redux/reducers/readinessCheck/attendeeReadinessCheck';
import screenShareCount from '@shoflo/studio-redux/reducers/screenShareCount/screenShareCount';
import { settings as broadcastSettings } from '@shoflo/studio-redux/reducers/settings/settings';
import uploadStatusVisibility from '@shoflo/studio-redux/reducers/source/uploadStatusVisibility';
import uploadStatus from '@shoflo/studio-redux/reducers/source/uploadStatus';
import sourceUpdateStatus from '@shoflo/studio-redux/reducers/source/sourceUpdateStatus';
import liveSources from '@shoflo/studio-redux/reducers/source/liveSources';
import broadcastSources from '@shoflo/studio-redux/reducers/source/sources';
import broadcastStreamEndpoints from '@shoflo/studio-redux/reducers/stream/streamEndpoints';
import { templates as broadcastTemplates } from '@shoflo/studio-redux/reducers/templates/templates';
import user from '@shoflo/studio-redux/reducers/user/user/user';
import isLoggedOut from '@shoflo/studio-redux/reducers/user/isLoggedOut/isLoggedOut';

import presenterSettingsSource from '@shoflo/studio-redux/reducers/presenters/presenterSettingsSource';

//User reducers
import loaders from './loader';
import features from './features';

//Event reducers
import event from '@shoflo/studio-redux/reducers/event/event';
import eventCrew from './eventCrew';

//Team reducers
import team from '@shoflo/studio-redux/reducers/team/team';

// import attendeeTiles from './attendeeTiles';
import attendeeMetrics from './attendeeMetrics';
import dismissedAttendees from './dismissedAttendees';

import sceneLayout from './sceneLayout';
import broadcastSourceDisconnectTimeouts from './broadcastSourceDisconnectTimeouts';
import attendeeTile from './attendeeTile';

//Sidebar
import sidebar from './sidebar';

//Show reducers
import broadcastScenes from './broadcastScenes';

import bannerTemplates from './bannerTemplates';

// SourcesTabs
import tabs from './tabs';

// Stage Sources
import stagedSources from './stagedSources';

// Templates
import templateTabs from './templatesTab';

// EditSourceOrder
import editSourceOrder from './EditSourceOrder/editSourceOrder';

// DragSource
import dragSource from './DragSource/dragSource';

// Music Profile
import attendeeContentShareAudioProfile from './attendeeContentShareAudioProfile';

// Recordings
import broadcastRecordings from './broadcastRecording';

import showStopStreamConfirmation from './showStopStreamConfirmation';

import featureFlags from './featureFlags';
import serverTimeDelta from './serverTimeDelta';

import scenesWithSource from './scenesWithSource';

import toggleNotificationList from './toggleNotificationList';

import broadcastSessionId from './broadcastSessionId';

import reloadBanner from './reloadBanner';

export default function reducer(history) {
  return combineReducers({
    router: connectRouter(history),
    loaders,
    modal,
    features,
    user,
    isLoggedOut,
    event,
    eventCrew,
    team,
    meeting,
    attendeePresence,
    attendeeRoster,
    attendeeMetrics,
    attendeeMuteStatus,
    dismissedAttendees,
    attendeeNetworkHealth,
    attendeeReceivedFrame,
    audioInputDevice,
    videoInputDevice,
    audioOutputDevice,
    program,
    sceneLayout,
    broadcastSources,
    broadcastSourceDisconnectTimeouts,
    broadcastStreamEndpoints,
    knocks,
    featuredPresenter,
    sidebar,
    broadcast,
    overlays,
    backgrounds,
    sceneLayers,
    mediaPlayerSettings,
    liveSources,
    bannerTemplates,
    banners,
    notification,
    uploadStatusVisibility,
    uploadStatus,
    tabs,
    attendeeCameraStatus,
    stagedSources,
    attendeeTile,
    broadcastSettings,
    broadcastTemplates,
    permissions,
    directorRequests,
    presenterSettingsSource,
    editSourceOrder,
    templateTabs,
    broadcastEventMedia,
    dragSource,
    attendeeContentShareAudioProfile,
    broadcastRecordings,
    showStopStreamConfirmation,
    broadcastScenes,
    startProgram,
    featureFlags,
    scenesWithSource,
    serverTimeDelta,
    toggleNotificationList,
    attendeeDetails,
    screenShareCount,
    broadcastSessionId,
    reloadBanner,
    sourceUpdateStatus,
    brandingSettings,
    readinessCheck,
    showReadinessCheck,
    sandboxMeetingStatus,
    sandboxMeetingSession,
    videoDeviceLost,
    userBackground,
    attendeeReadinessCheck,
    transformedVideoInputs,
    attendeeVoiceIntensity,
    broadcastRoles
  });
}
